import store from '~/store'

export default async (to, from, next) => {
  await store.dispatch('permission/fetchUserPermissionsAndActionTasks', { company: store.getters['auth/company'] })
  /* let userPermissions = await store.getters['permission/userPermissionsAndActionTasks']
  let componentIndex = await to.matched.findIndex((item, index) => {
    if (item.name === to.name) {
      return index
    }
  }) */

  /* I know It's fucking spaghetti code, but I really don't know how to realize this
   * On the first call, this data is Promise Func, but later it's just a variable
   */
  /* let component = (componentIndex > 0)
    ? (await to.matched[componentIndex].parent.components.default instanceof Function)
      ? await to.matched[componentIndex].parent.components.default()
      : await to.matched[componentIndex].parent.components.default
    : (await to.matched[componentIndex].components.default instanceof Function)
      ? await to.matched[componentIndex].components.default()
      : await to.matched[componentIndex].components.default */

  next()
  /* if (await checkPermission(userPermissions, component.metaInfo().title) === true) {
    next()
  } else {
    next({name: 'permission-alert'})
  } */
}

// todo fix not exist names of modules in DB
/*
async function checkPermission (permissions, moduleName) {
  let permissionName
  for (let permission of permissions) {
    permissionName = permission.app_permission.visible_name
    if (Array.isArray(moduleName.match(permissionName)) === true) {
      return true
    }
  }
  return false
}
*/



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/check-permission.js